import { PieChartOutlined, SmileOutlined } from '@ant-design/icons'

const agentMenus = [
  {
    label: 'Overview',
    key: '/home/overview',
    icon: <PieChartOutlined />,
  },
  {
    label: '学生管理',
    key: '学生管理',
    icon: <SmileOutlined />,
    children: [
      {
        label: '学生列表',
        key: '/home/student-list',
      },
    ],
  },

  {
    label: '套餐管理',
    key: '套餐管理',
    icon: <SmileOutlined />,
    children: [
      {
        label: '购卡列表',
        key: '/home/card-list',
      },
    ],
  },
]

export default agentMenus
